module.exports = __webpack_public_path__ + "img/tax-vat-charges.3e448b16.svg";